// ----------------------------------------------------------------------------- //
// 	Add class to input element's wrapper if it is filled
// ----------------------------------------------------------------------------- //
export default function detectInputHasValue( ref = document ) {

	const inputFields = ref.querySelectorAll('.input, .textarea');

	if ( inputFields.length ) {
		inputFields.forEach((item) => {
			item.addEventListener( "input", function () {
				const wrapper = this.closest('.form-item');
				this.value ? wrapper.classList.add('is-filled') : wrapper.classList.remove('is-filled');
			});
		});
	}
};
